import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function CTABanner() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-r from-dark-card to-dark-hover border border-dark-border rounded-2xl p-8 md:p-12 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-warm-50 mb-4">
            {t("home.cta.title")}
          </h2>
          <p className="text-warm-400 mb-8 max-w-xl mx-auto leading-relaxed">
            {t("home.cta.subtitle")}
          </p>
          <Link
            to="/downloads"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500 text-white font-semibold px-8 py-3 rounded-lg hover:opacity-90 transition-opacity"
          >
            {t("home.cta.button")}
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
